import React, { useState } from 'react';
import './Contact.css';
import { db } from '../../firebaseConfig';

import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";

const Contact = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [title, setTitle] = useState('');
    const [desc, setDesc] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const sendContact = e => {
        e.preventDefault();

        db.collection('contacts').add({
            ContactName: name,
            ContactTile: title,
            ContactDescription: desc,
            ContactEmail: email,
            ContactDate: new Date()
        }).then(() => {
            setName('');
            setEmail('');
            setTitle('');
            setDesc('');
            setError('');
            setSuccess('');
        }).then(() => setSuccess('Wiadomość została wysłana.')).catch(err => setError('Błąd. Spróbuj ponownie później.'));
    }

    return(
        <AnimationOnScroll animateIn="animate__fadeIn" className="contact">
            <form onSubmit={ sendContact }>
                <div className="form-field">
                    <label>Imię i nazwisko</label>
                    <input type="text" onChange={ e => setName(e.target.value) } value={ name } required />
                </div>
                <div className="form-field">
                    <label>Email</label>
                    <input type="email" onChange={ e => setEmail(e.target.value) } value={ email } required />
                </div>
                <div className="form-field">
                    <label>Tytuł</label>
                    <input type="text" onChange={ e => setTitle(e.target.value) } value={ title } required />
                </div>
                <div className="form-field">
                    <label>Opis</label>
                    <textarea onChange={ e => setDesc(e.target.value) } value={ desc } required ></textarea>
                </div>
                <button type="submit">Wyślij</button>
                { error !== '' &&
                    <div className="ui negative message">{ error }</div>
                }
                { success !== '' &&
                    <div className="ui positive message">{ success }</div>
                }
            </form>
        </AnimationOnScroll>
    );
}

export default Contact;